import * as Event from '../tools/Event';
import { fontLoader } from './fontFaceObserver';
import { addClass, removeClass, getItemsWidth } from '../tools/DOM';
import throttle from 'lodash.throttle';


export const init = () => {
	const elements = [...document.querySelectorAll('.m-tabs')];

	const prepare = (element) => {
		const LEFT_SCROLLABLE_CLASS = 'is-left-scrollable';
		const RIGHT_SCROLLABLE_CLASS = 'is-right-scrollable';
		const wrap = element.querySelector('.m-tabs__wrap');
		const items = [...element.querySelectorAll('.m-tabs__item')];
		let isInit = false;

		const init = () => {
			if (isInit) return;

			checkNav();

			isInit = true;
		};

		const update = () => {
			const wrapWidth = wrap.offsetWidth;
			const itemsWidth = getItemsWidth(items);

			if (itemsWidth > wrapWidth) {
				init();
			} else {
				destroy();
			}

			checkNav();
		};

		const destroy = () => {
			if (!isInit) return;

			removeClass(element, LEFT_SCROLLABLE_CLASS);
			removeClass(element, RIGHT_SCROLLABLE_CLASS);

			isInit = false;
		};

		const checkNav = () => {
			if (!isInit) return;

			const maxScroll = wrap.scrollWidth - wrap.clientWidth;
			const currentScroll = wrap.scrollLeft;

			if (currentScroll <= 0) {
				removeClass(element, LEFT_SCROLLABLE_CLASS);
			} else {
				addClass(element, LEFT_SCROLLABLE_CLASS);
			}

			if (currentScroll >= maxScroll) {
				removeClass(element, RIGHT_SCROLLABLE_CLASS);
			} else {
				addClass(element, RIGHT_SCROLLABLE_CLASS);
			}
		};


		fontLoader.then(() => update());

		Event.on(window, 'resize', throttle(update, 100));
		Event.on(wrap, 'scroll', throttle(checkNav, 100));
	};


	elements.forEach(prepare);
};



// WEBPACK FOOTER //
// ./src/js/components/menuTabs.js